module.exports = __webpack_public_path__ + "img/wsczzhjkyypt10.196f13ce.png";